var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconSpainFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C60A1D",
    d: "M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC400",
    d: "M0 12h36v12H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M9 17v3a3 3 0 1 0 6 0v-3H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4A2B2",
    d: "M12 16h3v3h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2E44",
    d: "M9 16h3v3H9z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EA596E",
    cx: 12,
    cy: 14.5,
    rx: 3,
    ry: 1.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFAC33",
    cx: 12,
    cy: 13.75,
    rx: 3,
    ry: 0.75
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M7 16h1v7H7zm9 0h1v7h-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#66757F",
    d: "M6 22h3v1H6zm9 0h3v1h-3zm-8-7h1v1H7zm9 0h1v1h-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconSpainFlag);
export default __webpack_public_path__ + "static/media/common_icon_spain_flag.435583dddffd0362546273c1acad4c7d.svg";
export { ForwardRef as ReactComponent };